import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./NegotiationsBar.css";
import NegotiationsBarListItem from "./NegotiationsBarListItem/NegotiationsBarListItem";
import NegotiationsBarDetails from "./NegotiationsBarDetails/NegotiationsBarDetails";
import axios from "axios";
function NegotiationsBar() {
	const userUID = useSelector(state => state.user.uid);

	const [selected, setSelected] = useState(false);
	const [formClass, setFormClass] = useState("");
	const [negotiation, setNegotiation] = useState("");
	const [proposal, setProposal] = useState(0);
	const [currentProposalUID, setCurrentProposalUID] = useState("");

	const [negotiationsList, setNegotiationsList] = useState([]);

	const onNegotiationsClick = option => {
		setFormClass(prev => (prev === "" ? "negotiationExpanded" : ""));
		setSelected(option);
	};

	useEffect(() => {
		if (userUID !== "none" && selected === true) {
			function fetchData() {
				const parameters = {
					action: 'Get_negotiations',
					ownerID: userUID,
					clientID: userUID
				}
				axios.post(`${process.env.REACT_APP_API_URL}`, parameters)
					.then(response => {
						setNegotiationsList(response.data.data)
					})
					.catch(error => {
						console.log(error)
					});
			}
			fetchData();
			const interval = setInterval(() => {
				fetchData()
			}, 15000);

			return () => clearInterval(interval);
		}

	}, [userUID, selected]);

	// async function handleTestButton(){
	// 	console.log("Gracias por presionarme");
	// 	const {resp, error} = FireStoreService.deleteDoc(
	// 		"/negotiations/uYyqka8RKvVp290XMU67/messages",
	// 		'w18Xb5YDsMJCJwciq22s')
	// 	console.log(resp);
	// 	console.log(error);
	// }

	function onClickNegotiation(negotiation, proposal, currentProposalUID) {
		setNegotiation(negotiation);
		setProposal(proposal);
		setCurrentProposalUID(currentProposalUID);
	}

	return (
		<>
			<div className={`negotiationsContainer ${formClass}`}>
				<span
					className={`negotiations_close_button search__map__toggle material-icons `}
					onClick={() => onNegotiationsClick(false)}
				>
					<i className="la la-close"></i>
				</span>

				<div className="negotiationsContainer_details">
					{!negotiation ? (
						<div className="negotiationsContainer_details_emptyMessage">
							<div>
								Keep you informed about <br /> your Negotiations
							</div>
							<div className="negotiationsContainer_details_emptyMessage_icon">
								<span className="material-icons emptyNegotiation">
									<i className="la la-list-alt"></i>
								</span>
							</div>
							<div className="negotiationsContainer_details_emptyMessage_help">
								<span>White Items are garages you want to rent</span>
								<br />
								<span>Green Items are garages you own.</span>
								<br />
								<br />
								<span>You may also check closed negotiations.</span>
							</div>
							{/* <span className= "negotiationsContainer_details_emptyMessage_help" >Deal Closed</span> */}
							{/* <button onClick={()=>handleTestButton()}> Presionameee</button> */}
						</div>
					) : (
						<NegotiationsBarDetails
							negotiationID={negotiation}
							setSelected={setSelected}
							setFormClass={setFormClass}
							proposal={proposal}
							currentProposalUID={currentProposalUID}
						/>
					)}
				</div>
				<div className="negotiationsContainer_list">
					<span className="negotiationsContainer_list_title">
						My Negotiations
					</span>
					{negotiationsList && negotiationsList.length > 0 &&
						<NegotiationsBarListItem
							onClickNegotiation={onClickNegotiation}
							negotiationsList={negotiationsList}
						/>
					}
				</div>
			</div>
			<div
				className={`negotiationsButton ${!selected ? "buttonShowing" : "buttonHidden"
					}`}
				onClick={() => onNegotiationsClick(true)}
			>
				{selected === true ? null : (
					<div className="negotiationsCircle">
						<div className="negotiationsCircle_interior">
							<div className="negotiationsCircle_interior_info">
								<span className="material-icons negotiation"><i className="la la-comment"></i></span>
								<h6 className="text-white font-weight-bold small">My Negotiation</h6>
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
}

export default NegotiationsBar;
